import React, { useEffect, useState } from 'react'
import { apiClient } from './Axios';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {

    const [isAuthenticated, setIsAuthenticated] = useState(null);


    useEffect(() => {
        const isVerify = () => {
            apiClient.get("/auth/verify").then(res => {
                setIsAuthenticated(true)
            }).catch(err => {
                setIsAuthenticated(false)
            })
        }
        isVerify()
    }, [])


    if (isAuthenticated === null) {
        return (
            <div>Loading...</div>
        )
    }

    return isAuthenticated ? children : <Navigate to='/account/login' />

}

export default ProtectedRoute